<script lang="ts">
    import { Col, Pagination, PaginationItem, PaginationLink } from "sveltestrap";
    import Card from "../../Core/Card.svelte";
    import data from "../../../Data/BonusUi/BonusUi.json"
    import { href, Next, Previous } from "../../../utils/Constant/Constant";
</script>
<Col xl="12">
    <Card headerTitle="Pagination Alignment" cardHeaderprops="pb-0">
        <div slot="contentbody" >
          {#each data.paginationdata as paginationItem}
            <nav class="m-b-30" aria-label="Page navigation example">
                <Pagination class="pagination {paginationItem.class} pagination-primary" aria-label="Page navigation example">
                    <PaginationItem>
                        <PaginationLink href={href}>{Previous}</PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                        <PaginationLink href={href}>{"1"}</PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                        <PaginationLink href={href}>{"2"}</PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                        <PaginationLink href={href}>{"3"}</PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                        <PaginationLink href={href}>{Next}</PaginationLink>
                    </PaginationItem>
                </Pagination>
            </nav>
          {/each}
        </div>   
    </Card> 
</Col>